import React from 'react'
import Button from '@mui/material/Button'
import { Box, Grid, useMediaQuery } from '@mui/material'
import { makeStyles } from '@mui/styles'
import approvalActions from './actions'
import ReuseAction from 'components/common/ReuseAction'

const useStyles = makeStyles((theme) => ({
    success: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.success.main,
        color: '#FFF',
        '&:hover': {
            backgroundColor: theme.palette.success.main,
            color: '#FFF',
        },
    },
    error: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.error.main,
        color: '#FFF',
        '&:hover': {
            backgroundColor: theme.palette.error.main,
            color: '#FFF',
        },
    },
}))

const TableActions = () => {
    const classes = useStyles()
    const { updatePendingUser } = approvalActions()
    const approve = () => {
        updatePendingUser('approve')
    }
    const deny = () => {
        updatePendingUser('deny')
    }
    const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'))

    const getActions = () => (
        <Grid
            container
            justify={matches ? 'flex-start' : 'center'}
            alignContent="center"
            direction="row"
            gap={1}
        >
            <Button
                size={matches ? 'small' : 'large'}
                onClick={() => setTimeout(() => approve(), 0)}
                color="primary"
                variant="outlined"
            >
                Approve
            </Button>
            <Button
                size={matches ? 'small' : 'large'}
                onClick={() => setTimeout(() => deny(), 0)}
                color="error"
                variant="outlined"
            >
                Deny
            </Button>
        </Grid>
    )
    return matches ? (
        getActions()
    ) : (
        <ReuseAction actions={<Box m={2}>{getActions()}</Box>} />
    )
}

export default TableActions
